// import {getToken} from '@/libs/auth';

export default {
    data() {
        return {
            //数据来源
            system_source: 'WEB',
        };
    },
    computed: {},
    methods: {
        //路由跳转
        url_to_link(url_params, resolve) {
            const {path, name} = url_params;
            if ((!path && !name) || (name && this.$route.name === name)) return;
            // if (typeof resolve === 'undefined') {
            //     const name = this.$route.name;
            //     resolve = (name === 'home');
            // }
            if (resolve) {
                const {href} = this.$router.resolve(url_params);
                window.open(href, '_blank'); //打开新的窗口
            } else this.$router.push(url_params);
        },
        //路由跳转
        url_event(e) {
            this.url_to_link(e.currentTarget.dataset);
        },
        //新页面打开
        url_event_blank(e) {
            this.url_to_link(e.currentTarget.dataset, true);
        },
        get_text_html(str,num = 20){
            if(str){
                const paragraphs = str.split('\n');
                let htmlString = '';
                paragraphs.forEach(paragraph => {
                    // 创建一个<p>标签，并设置其内容
                    htmlString += `<p class="mr-t-${num}">${paragraph}</p>`;
                });
                return htmlString;
            }else{
                return '';
            }
        },
    }
};
